export default "__VITE_ASSET__11d87094__"